module.exports = __webpack_public_path__ + "login_bg.86416cfd012b05470042.png";


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/assets/login_bg.png
// module id = ../../../../../src/assets/login_bg.png
// module chunks = 0